import React from "react";
import {
  Box,
  SimpleGrid,
  Text,
  useColorMode,
  Icon,
} from "@chakra-ui/react";
import { motion } from "framer-motion";
import {
  SiJavascript,
  SiReact,
  SiCss3,
  SiPostman,
  SiMongodb,
  SiChakraui,
  SiRedux,
  SiAliexpress
} from "react-icons/si";
import {
  GrNode,
  GrMysql,
} from "react-icons/gr";
import {
  AiFillHtml5,
  AiFillApi,
} from "react-icons/ai";
import { FaGithub, FaNpm } from "react-icons/fa";

const skillsData = {
  frontend: [
    { icon: SiJavascript, title: "JavaScript" },
    { icon: SiReact, title: "React" },
    { icon: SiCss3, title: "CSS" },
    { icon: AiFillHtml5, title: "HTML5" },
    { icon: SiChakraui, title: "Chakra-ui" },
    { icon: SiRedux, title: "Redux" }
    
  ],
  backend: [
    { icon: GrNode, title: "Node.js" },
    { icon: SiMongodb, title: "MongoDB" },
    { icon: SiAliexpress, title: "Express.js" }
   
  ],
  tools: [
    { icon: FaGithub, title: "GitHub" },
    { icon: SiPostman, title: "Postman" },
    { icon: FaNpm, title: "NPM" }
    
  ],
};

const SkillsP = () => {
  const { colorMode } = useColorMode();
  const isDark = colorMode === "dark";

  return (
    <Box p={8}>
      <Text
        fontSize="3xl"
        textAlign="center"
        fontWeight="bold"
        color={isDark ? "white" : "gray.800"}
        mb={8}
        fontFamily="monospace"
      >
        My Skills
      </Text>
      
      
      <Text
        fontSize="xl"
        fontWeight="semibold"
        color={isDark ? "white" : "gray.800"}
        mb={4}
      >
        Front-end Skills
      </Text>
      <SimpleGrid columns={{ base: 2, md: 4 }} spacing={8}>
        {skillsData.frontend.map((item, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.2, duration: 0.6 }}
          >
            <Box
              p={4}
              bg={isDark ? "gray.800" : "gray.100"}
              borderRadius="lg"
              boxShadow="lg"
              border="2px solid"
              borderColor={isDark ? "blue.400" : "blue.600"}
              _hover={{
                transform: "scale(1.05)",
                boxShadow: "xl",
              }}
            >
              <Icon as={item.icon} boxSize={12} color="blue.500" />
              <Text
                mt={2}
                fontWeight="semibold"
                color={isDark ? "white" : "gray.800"}
                fontFamily="body"
                textAlign="center"
              >
                {item.title}
              </Text>
            </Box>
          </motion.div>
        ))}
      </SimpleGrid>

    
      <Text
        fontSize="xl"
        fontWeight="semibold"
        color={isDark ? "white" : "gray.800"}
        my={8}
      >
        Back-end Skills
      </Text>
      <SimpleGrid columns={{ base: 2, md: 4 }} spacing={8}>
        {skillsData.backend.map((item, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.2, duration: 0.6 }}
          >
            <Box
              p={4}
              bg={isDark ? "gray.800" : "gray.100"}
              borderRadius="lg"
              boxShadow="lg"
              border="2px solid"
              borderColor={isDark ? "green.400" : "green.600"}
              _hover={{
                transform: "scale(1.05)",
                boxShadow: "xl",
              }}
            >
              <Icon as={item.icon} boxSize={12} color="green.500" />
              <Text
                mt={2}
                fontWeight="semibold"
                color={isDark ? "white" : "gray.800"}
                fontFamily="body"
                textAlign="center"
              >
                {item.title}
              </Text>
            </Box>
          </motion.div>
        ))}
      </SimpleGrid>

      
      <Text
        fontSize="xl"
        fontWeight="semibold"
        color={isDark ? "white" : "gray.800"}
        my={8}
      >
        Tools
      </Text>
      <SimpleGrid columns={{ base: 2, md: 4 }} spacing={8}>
        {skillsData.tools.map((item, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.2, duration: 0.6 }}
          >
            <Box
              p={4}
              bg={isDark ? "gray.800" : "gray.100"}
              borderRadius="lg"
              boxShadow="lg"
              border="2px solid"
              borderColor={isDark ? "purple.400" : "purple.600"}
              _hover={{
                transform: "scale(1.05)",
                boxShadow: "xl",
              }}
            >
              <Icon as={item.icon} boxSize={12} color="purple.500" />
              <Text
                mt={2}
                fontWeight="semibold"
                color={isDark ? "white" : "gray.800"}
                fontFamily="body"
                textAlign="center"
              >
                {item.title}
              </Text>
            </Box>
          </motion.div>
        ))}
      </SimpleGrid>
    </Box>
  );
};

export default SkillsP;
